import script from "./home.vue?vue&type=script&setup=true&name=home&lang=js"
export * from "./home.vue?vue&type=script&setup=true&name=home&lang=js"

import "./home.vue?vue&type=style&index=0&id=328a6ed5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328a6ed5"]])

export default __exports__